<template>
  <span>{{ getCityRegionName(cityRegionId) }}</span>
</template>
<script>
export default {
  name: "cityRegionShow",
  props: {
    cityRegionId: {
      type: [String, Number],
      required: true
    },
    orderDetail: {
      type: Object,
      required: true
    }
  },
  computed: {
    cityRegionList() {
      return this.orderDetail.cityRegionList
    }
  },
  methods: {
    getCityRegionName(id) {
      if (!id || !this.cityRegionList) {
        return '';
      }
      const cityRegion = this.cityRegionList.find(item => item.id === id);
      return cityRegion ? cityRegion.name : '';
    }
  }
}

</script>

<style scoped>

</style>
